module.exports = __webpack_public_path__ + "img/05.5f2719bc.png";